import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

interface UseSignOutOptions {
  onSuccess?: () => void;
}

export function useSignOut(options?: UseSignOutOptions) {
  const client = useSupabase();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return client.auth.signOut();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['session'] });
      queryClient.invalidateQueries({ queryKey: ['user-role'] });
      queryClient.invalidateQueries({ queryKey: ['team-account'] });

      options?.onSuccess?.();
    },
  });
}
